module.exports = __webpack_public_path__ + "static/media/bowen-63.532ce406.jpg";